module.exports = __webpack_public_path__ + "static/media/img-ovato-coin-stack-new.69633d37.pdf";